// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  /* The root element's background propagates across the whole canvas,
     including the iOS safe areas, so they show our paper color instead of the
     WebView's default white. */
  background: var(--palette-bg, #fbf7f0);
}
body {
  margin: 0;
  border: 0;
  padding: 0;
  background: var(--palette-bg, #fbf7f0);
  overscroll-behavior: none;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

h1 {
  padding: 10px;
}

input {
  width: 400px;
}

.clickable {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE;;+BAE6B;EAC7B,sCAAsC;AACxC;AACA;EACE,SAAS;EACT,SAAS;EACT,UAAU;EACV,sCAAsC;EACtC,yBAAyB;EACzB,4DAA4D;AAC9D;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB","sourcesContent":["html {\n  /* The root element's background propagates across the whole canvas,\n     including the iOS safe areas, so they show our paper color instead of the\n     WebView's default white. */\n  background: var(--palette-bg, #fbf7f0);\n}\nbody {\n  margin: 0;\n  border: 0;\n  padding: 0;\n  background: var(--palette-bg, #fbf7f0);\n  overscroll-behavior: none;\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n}\n\nh1 {\n  padding: 10px;\n}\n\ninput {\n  width: 400px;\n}\n\n.clickable {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
